import './styles.css';
import React, { useContext, useState } from 'react';
import { Button, Card, Form, Input } from 'antd';
import { withRouter } from 'react-router-dom';
import { AppContext } from '../../../state/ContextProvider';
import { UPDATE_CREDENTIALS } from '../../../state/actions';
import { globalLoginAPI } from '../../../utils/apis';
import APIHelper from '../../../utils/APIHelper';

const { Item, useForm } = Form;

const EMAIL = 'email';
const PASSWORD = 'password';
const ACCOUNTS_PAGE = '/accounts';
const FORGOT_PASSWORD_PAGE = '/forgot-password';

const LoginForm = ({ history, popUpNotification }) => {
  const [form] = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const { dispatcher } = useContext(AppContext);

  const onFinish = async (values) => {
    try {
      setIsLoading(true);
      const accounts = await globalLoginAPI.doPost(values);
      setIsLoading(false);

      if (accounts.length === 1) {
        // redirect straight to the app's session
        const account = accounts[0];
        window.open(
          `${account.url}/redirect?tokenId=${account.jwtId}`,
          '_self'
        );
      } else {
        // redirect to the accounts page
        dispatcher({ type: UPDATE_CREDENTIALS, accounts });
        history.push(ACCOUNTS_PAGE);
      }
    } catch (error) {
      if (error.message.includes(APIHelper.INVALID_CREDENTIALS_ERROR_MESSAGE)) {
        popUpNotification('error', {
          title: 'Invalid Credentials',
          description: 'Please check your email and password',
        });
      } else {
        popUpNotification('error', {
          title: 'Unexpected Error',
          description: 'Something went wrong, please try again later',
        });
      }
      setIsLoading(false); // needed at the end so notification are not displayed twice
    }
  };

  return (
    <Card className={'login-card'}>
      <Form
        form={form}
        layout="vertical"
        style={{ display: 'flex', flexDirection: 'column' }}
        onFinish={onFinish}
        aria-label="login-form"
      >
        <Item
          name={EMAIL}
          label="Email"
          required
          rules={[
            {
              type: 'email',
              message: 'Invalid email address',
            },
            { required: true },
          ]}
        >
          <Input />
        </Item>
        <Item
          name={PASSWORD}
          label="Password"
          required
          rules={[{ required: true }]}
        >
          <Input.Password />
        </Item>
        <Button type="primary" htmlType="submit" loading={isLoading}>
          Login
        </Button>
        <Button
          type="link"
          className={'btn-link'}
          onClick={() => history.push(FORGOT_PASSWORD_PAGE)}
        >
          Forgot password
        </Button>
      </Form>
    </Card>
  );
};

export default withRouter(LoginForm);
